import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import logo from "@/assets/logo-new.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (item: { id: string; isLink?: boolean }) => {
    if (item.isLink) {
      navigate(`/${item.id}`);
    } else if (location.pathname !== '/') {
      navigate(`/#${item.id}`);
    } else {
      document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const handleCall = () => {
    const url = 'tel:+48571315854';
    let called = false;
    const redirect = () => { if (!called) { called = true; window.location.href = url; } };
    if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', 'conversion', {
        'send_to': 'AW-858383916/09TJCJaFmvEbEKzMp5kD',
        'event_callback': redirect
      });
      setTimeout(redirect, 1000);
    } else {
      redirect();
    }
  };

  const navItems = [
    { label: 'Efekty', id: 'gallery' },
    { label: 'Cennik', id: 'pricing' },
    { label: 'O mnie', id: 'expert' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Blog', id: 'blog', isLink: true },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background/98 backdrop-blur-xl shadow-soft py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3">
            <img src={logo} alt="Magiczna Keratyna" className="h-12 w-auto" width={48} height={48} loading="eager" />
            <span className="font-semibold text-base sm:text-lg tracking-wide text-foreground">
              Magiczna Keratyna
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item)}
                className="text-muted-foreground hover:text-foreground transition-colors duration-300 gold-underline text-sm font-medium tracking-wide"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <button
            onClick={handleCall}
            className="hidden md:flex items-center gap-2 btn-primary text-sm py-2.5 px-6"
          >
            <Phone className="w-4 h-4" />
            <span>Zadzwoń</span>
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center"
            aria-label={isMobileMenuOpen ? "Zamknij menu" : "Otwórz menu"}
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-foreground" />
            ) : (
              <Menu className="w-6 h-6 text-foreground" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-background/98 backdrop-blur-xl border-b border-border/50 animate-fade-in">
            <nav className="flex flex-col p-5 gap-1">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavClick(item)}
                  className="text-left py-3.5 px-4 text-foreground hover:bg-secondary/50 rounded-xl transition-colors font-medium"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => handleNavClick({ id: 'quiz' })}
                className="btn-primary text-center mt-3"
              >
                Oblicz koszt
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
